import React from 'react';
import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import { Link, Stack, Button, Tooltip, IconButton } from '@mui/material';
//
import Iconify from './Iconify';
import { openUrl } from '../utils/miscellaneous';

// ----------------------------------------------------------------------

SocialsButton.propTypes = {
  initialColor: PropTypes.bool,
  links: PropTypes.objectOf(PropTypes.string),
  simple: PropTypes.bool,
  sx: PropTypes.object,
};

export default function SocialsButton({
  initialColor = false,
  simple = false,
  links = {},
  sx,
  ...other
}) {
  const SOCIALS = [
    {
      name: 'FaceBook',
      icon: 'eva:facebook-fill',
      socialColor: '#1877F2',
      path: links.facebook,
    },
    {
      name: 'Instagram',
      icon: 'ant-design:instagram-filled',
      socialColor: '#E02D69',
      path: links.instagram,
    },
    {
      name: 'Linkedin',
      icon: 'eva:linkedin-fill',
      socialColor: '#007EBB',
      path: links.linkedin,
    },
    {
      name: 'Twitter',
      icon: 'eva:twitter-fill',
      socialColor: '#00AAEC',
      path: links.twitter,
    },
    {
      name: 'Tiktok',
      icon: 'ic:baseline-tiktok',
      socialColor: '#222',
      path: links.tiktok,
    },
    {
      name: 'Youtube',
      icon: 'mdi:youtube',
      socialColor: '#FF0000',
      path: links.youtube,
    },
  ].filter((social) => !!social.path);

  return (
    <Stack
    sx={{mt: 1, ml: 0}}
      direction="row"
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {SOCIALS.map((social) => {
        const { name, icon, path, socialColor } = social;
        return simple ? (
          <Link
            key={name}
            onClick={() => {
              if (path) {
                openUrl(path);
              }
            }}
          >
            <Tooltip title={name} placement="top">
              <IconButton
                color="text.secondary"
                sx={{
                  ...(initialColor && {
                    'color': socialColor,
                    '&:hover': {
                      bgcolor: alpha(socialColor, 0.08),
                    },
                  }),
                  ...sx,
                }}
                {...other}
              >
                <Iconify icon={icon} sx={{ width: 24, height: 24 }} />
              </IconButton>
            </Tooltip>
          </Link>
        ) : (
          <Button
            key={name}
            onClick={() => {
              if (path) {
                openUrl(path);
              }
            }}
            variant="outlined"
            size="small"
            startIcon={<Iconify icon={icon} />}
            sx={{
              m: 0.5,
              flexShrink: 0,
              ...(initialColor
                ? {
                    'color': socialColor,
                    'borderColor': socialColor,
                    '&:hover': {
                      borderColor: socialColor,
                      bgcolor: alpha(socialColor, 0.08),
                    },
                  }
                : {
                    color: 'text.secondary',
                  }),
              ...sx,
            }}
            {...other}
          >
            {name}
          </Button>
        );
      })}
    </Stack>
  );
}
